import { handleResponse, post } from '../utils/network';
import config from '../utils/config';
import posthog from 'posthog-js';

export const sleep = (timeMS, onTimer) =>
  new Promise((resolve, reject) => setTimeout(() => onTimer(resolve, reject), timeMS));

export const deleteCookie = name => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
};

export const getCookie = name => {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
};

export const setCookie = (name, value) => {
  document.cookie = `${name}=${value}; max-age=${config.cookieMaxAge}`;
};

export const isLogged = () => getCookie('isLogged');

export const handleLogout = (history) => {
  posthog.reset();
  post('entraid/signout')
    .then(res => handleResponse(res, { history }))
    .then(parsedResponse => {
      deleteCookie('isLogged');
      deleteCookie('routeOptions');
      deleteCookie('userId');
      deleteCookie('name');
      deleteCookie('signUpOrigin');
      window.location.href = parsedResponse.message
    });
};


export const buildUrlQueryString = (endpoint, filters) => {
  const url = endpoint + "?" + Object.keys(filters)
    .filter(key => ![undefined, "", null].includes(filters[key]))
    .map(key => `${key}=${filters[key]}`)
    .join('&');

  return url === endpoint + "?" ? endpoint : url
}


export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);